"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _popupStyles = require("./popupStyles");

var _popupHtml = require("./popupHtml");

var _index = require("./images/index");

var _messageCreator = require("./messageCreator");

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// import debugLogger from 'debug';
// TODO add debug logging
// const debug = debugLogger('MEWconnect:popup-handler');
var PopUpHandler = /*#__PURE__*/function () {
  function PopUpHandler() {
    _classCallCheck(this, PopUpHandler);

    this.index = 0;
    this.checkCount = 0;
    this.elementId = 'mew-connect-notice-corner';
    this.connectedElementId = this.elementId + '-connected';
    this.initialcheckIfIdExists();
    this.createNotice();
    this.timeoutTracker = null;
    this.lastActiveElement = '';
    this.connectNoticeVisible = false;
  }

  _createClass(PopUpHandler, [{
    key: "initialcheckIfIdExists",
    value: function initialcheckIfIdExists() {
      var element = window.document.getElementById(this.elementId);

      if (element) {
        this.checkCount++;
        this.elementId = this.elementId + "-".concat(this.checkCount);
        this.connectedElementId = this.elementId + '-connected';
        this.initialcheckIfIdExists();
      }
    }
  }, {
    key: "showNotice",
    value: function showNotice(text) {
      var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var timeoutTime = 3800;
      var timeoutOverride = false;

      if (_typeof(text) === 'object') {
        text = (0, _messageCreator.getMessage)(null, text);
      } else {
        text = (0, _messageCreator.getMessage)(text);
      }

      if (!text) {
        text = 'Check your phone to continue';
      }

      if (typeof overrides === 'number') {
        timeoutTime = overrides;
        timeoutOverride = true;
      }

      var element = window.document.getElementById(this.elementId);
      this.lastActiveElement = element;

      if (!timeoutOverride) {
        element.className = 'show';
        var elementText = window.document.getElementById("".concat(this.elementId, "-text"));
        elementText.innerHTML = text;
        setTimeout(function () {
          element.className = element.className.replace('show', '');
        }, timeoutTime);
      } else {
        element.className = 'show-in';

        var _elementText = window.document.getElementById("".concat(this.elementId, "-text"));

        _elementText.innerHTML = text;
        setTimeout(function () {
          element.className = element.className.replace('show-in', 'show-out');
        }, timeoutTime - 500);
        this.timeoutTracker = setTimeout(function () {
          element.className = element.className.replace('show-out', '');
        }, timeoutTime);
      }
    }
  }, {
    key: "showConnectedNotice",
    value: function showConnectedNotice(text, overrides) {
      var timeoutTime = 3800;
      var timeoutOverride = false;

      if (typeof overrides === 'number') {
        timeoutTime = overrides;
        timeoutOverride = true;
      }

      var element = window.document.getElementById(this.connectedElementId);
      this.lastActiveElement = element;

      if (!timeoutOverride) {
        element.className = 'show';
        setTimeout(function () {
          element.className = element.className.replace('show', '');
          this.connectNoticeVisible = true;
        }, timeoutTime);
      } else {
        element.className = 'show-in';
        setTimeout(function () {
          element.className = element.className.replace('show-in', 'show-out');
          this.connectNoticeVisible = true;
        }, timeoutTime - 500);
        this.timeoutTracker = setTimeout(function () {
          element.className = element.className.replace('show-out', '');
          this.connectNoticeVisible = false;
          this.lastActiveElement = null;
        }, timeoutTime);
      }
    }
  }, {
    key: "showNoticePersistentEnter",
    value: function showNoticePersistentEnter(text) {
      if (_typeof(text) === 'object') {
        text = (0, _messageCreator.getMessage)(null, text);
      } else {
        text = (0, _messageCreator.getMessage)(text);
      }

      var element = window.document.getElementById(this.elementId);
      element.className = 'show-persistent';
      var elementText = window.document.getElementById("".concat(this.elementId, "-text"));
      elementText.innerHTML = text;
      this.timeoutTracker = setTimeout(function () {
        element.className = element.className.replace('show-persistent', '');
      }, 10800);
    }
  }, {
    key: "showNoticePersistentExit",
    value: function showNoticePersistentExit() {
      if (this.timeoutTracker) {
        clearTimeout(this.timeoutTracker);
        var element = window.document.getElementById(this.elementId);
        element.className = element.className.replace('show-persistent', 'show-persistent-leave');
        this.timeoutTracker = setTimeout(function () {
          element.className = element.className.replace('show-persistent-leave', '');
        }, 1800);
      }
    }
  }, {
    key: "noShow",
    value: function noShow() {
      if (this.timeoutTracker) {
        clearTimeout(this.timeoutTracker);
      }

      var element = window.document.getElementById(this.elementId);
      element.className = '';
    }
  }, {
    key: "createNotice",
    value: function createNotice() {
      var _this = this;

      this.index++;
      var div = window.document.createElement('div');
      div.id = this.elementId;
      div.innerHTML = (0, _popupHtml.noticeHtml)(this.elementId, _index.spaceman, _index.closeIconBlack);
      window.document.body.appendChild(div);
      var css = document.createElement('style');
      css.type = 'text/css';
      if ('textContent' in css) css.textContent = (0, _popupStyles.notifierCSS)(this.elementId);else css.innerText = (0, _popupStyles.notifierCSS)(this.elementId);
      document.body.appendChild(css);
      var closeEl = document.getElementById(this.elementId + '-close');
      closeEl.addEventListener('click', function () {
        var el = document.getElementById(_this.elementId);

        if (_this.timeoutTracker) {
          clearTimeout(_this.timeoutTracker);
        }

        el.className = el.className.replace('show', '');
      }); // create connected notice

      var divConn = window.document.createElement('div');
      divConn.id = this.connectedElementId;
      divConn.innerHTML = (0, _popupHtml.connectedNoticeHtml)(this.connectedElementId, _index.spaceman, _index.closeIconWhite);
      window.document.body.appendChild(divConn);
      var cssConn = document.createElement('style');
      cssConn.type = 'text/css';
      if ('textContent' in cssConn) cssConn.textContent = (0, _popupStyles.connectedNotifierCSS)(this.connectedElementId);else cssConn.innerText = (0, _popupStyles.connectedNotifierCSS)(this.connectedElementId);
      document.body.appendChild(cssConn);
      var closeElConn = document.getElementById(this.connectedElementId + '-close');
      closeElConn.addEventListener('click', function () {
        var el = document.getElementById(_this.connectedElementId);

        if (_this.timeoutTracker) {
          clearTimeout(_this.timeoutTracker);
        }

        el.className = el.className.replace('show', '');
      });
    }
  }, {
    key: "hideNotifier",
    value: function hideNotifier() {
      var notify = document.getElementById('Notifications');

      if (notify) {
        notify.className = 'hidden';
      }
    }
  }]);

  return PopUpHandler;
}();

exports.default = PopUpHandler;